module.exports = __webpack_public_path__ + "assets/UserSelection-min.5fa0487cb9551331189c79f04a7bfe39.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Aplifit/UserSelection-min.jpg
 ** module id = 395
 ** module chunks = 0
 **/